// extracted by mini-css-extract-plugin
module.exports = {"root":"PopupForm_root__2BMAY","blur":"PopupForm_blur__1oPEy"};